/**
 * Общие преобразования данных акта приемки-передачи ТС.
 * Здесь нет состояния мастера или API-вызовов: утилита только формирует
 * однозначные значения для ответов и отображения статусов.
 */

const STATUS_LABELS = {
  draft: "Черновик",
  awaiting_signatures: "Ждёт подписей",
  signed: "Подписан",
  cancelled: "Отменён",
};

const STATUS_COLORS = {
  draft: "color-mix(in srgb, var(--color-dark) 65%, var(--color-light))",
  awaiting_signatures: "var(--color-yellow)",
  signed: "color-mix(in srgb, var(--color-green) 55%, var(--color-dark))",
  cancelled: "color-mix(in srgb, var(--color-dark) 65%, var(--color-light))",
};

/** Приводит сохранённую конфигурацию шага к объекту независимо от формата API. */
export function parseVehicleInspectionStepConfig(config) {
  return typeof config === "string" ? JSON.parse(config) : (config || {});
}

/**
 * Формирует результат фотоэтапа. Пропуск всегда возвращает пустой список
 * вложений, чтобы частичное обновление явно удалило ранее сохранённое фото.
 */
export function buildVehicleInspectionPhotoCompletion({
  file = null,
  attachments = [],
  skipped = false,
} = {}) {
  if (skipped) return { value: {}, attachmentIds: [] };

  return {
    file,
    attachmentIds: file ? undefined : attachments.map((attachment) => attachment.id),
    value: { confirmed: true },
  };
}

/** Возвращает пользовательское название статуса акта или исходное значение. */
export function formatVehicleInspectionStatusLabel(status) {
  return STATUS_LABELS[status] || status;
}

/** Возвращает единый цвет статуса акта для списков и подробной карточки. */
export function getVehicleInspectionStatusColor(status) {
  return STATUS_COLORS[status] || STATUS_COLORS.draft;
}

/**
 * Поясняет ожидание подписи относительно текущего пользователя. Чужую подпись
 * нельзя показывать как собственную: для этого участник ищется именно по user_id.
 */
export function formatVehicleInspectionWaitingMessage(inspection, currentUserId) {
  if (inspection?.status !== "awaiting_signatures" || currentUserId == null) return "";

  const participants = inspection.participants || [];
  const currentParticipant = participants.find(
    (participant) => String(participant.user_id) === String(currentUserId)
  );

  if (currentParticipant?.signed_at) {
    const pendingParticipant = participants.find((participant) => !participant.signed_at);
    const pendingRole = pendingParticipant?.participation_role || oppositeRole(currentParticipant.participation_role);
    const pendingRoleLabel = { giver: "сдающего", receiver: "принимающего" }[pendingRole];

    return pendingRoleLabel
      ? `Вы подписали акт. Ожидается подпись ${pendingRoleLabel}.`
      : "Вы подписали акт. Ожидается подпись второй стороны.";
  }

  return inspection.can_sign ? "Акт ожидает вашей подписи." : "";
}

function oppositeRole(role) {
  if (role === "giver") return "receiver";
  if (role === "receiver") return "giver";

  return null;
}
